import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ConsentBanner } from "@/components/ConsentBanner";

export const Layout = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-white">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <ConsentBanner />
  </div>
);
